import {
    CUSTOM_OPTION_OPEN,
    CUSTOM_OPTION_VALUES,
    READY_FOR_ADD,
} from "./productActionTypes";

export type productStateType = {
    customOptionOpen: number[];
    optionValues: {
        id: number;
        label: string;
        price: string;
        optionId: number
    }[];
    notFilledOptions: number[];
    loading: boolean | null;
}


const initialState: productStateType = {
    customOptionOpen: [],
    optionValues: [],
    notFilledOptions: [],
    loading: null,
};

export default function productReducer(state = initialState, action: any) {
    switch (action.type) {
        case CUSTOM_OPTION_OPEN:
            const { isOutsideClick } = action.meta || {isOutsideClick: false};
            const { optionId: openOptionId } = action.payload || {};
            const { customOptionOpen } = state || [];
            let updatedOptionOpen: number[] = [];
            if (!isOutsideClick) {
                const existItem = customOptionOpen.find((item) => item === openOptionId);
                if (existItem) {
                    updatedOptionOpen = customOptionOpen.filter((item) => item !== openOptionId);
                } else {
                    updatedOptionOpen = [...customOptionOpen, openOptionId];
                }
            }
            return {
                ...state,
                customOptionOpen: updatedOptionOpen
            };
        case CUSTOM_OPTION_VALUES:
            const { id, label, price, optionId } = action.payload || {};
            const { isConfig, isFiltered } = action.meta || { isConfig: false, isFiltered: false };
            const { optionValues } = state;
            const handleOptionId = optionValues.find((el) => el?.id === id);
            const handleOptionLabel = optionValues.find((el) => el?.label === label);
            let updatedOptionValues = optionValues;
            if (isConfig) {
                updatedOptionValues = [];
            } else if (isFiltered) {
                updatedOptionValues = optionValues.filter(el => el.id !== id);
            } else {
                if (!handleOptionId) {
                    updatedOptionValues = [...optionValues, {id, label, price, optionId}];
                } else if (handleOptionId && !handleOptionLabel) {
                    updatedOptionValues = optionValues.map(el => el.id === id ? {...el, label, price, optionId} : el);
                }
            }
            return {
                ...state,
                optionValues: updatedOptionValues,
                loading: null
            };
        case READY_FOR_ADD:
            return {
                ...state,
                notFilledOptions: action.payload,
            };
        default:
            return state;
    }
}
